import React from 'react';

export interface FormContainerHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
    /** Title of the form */
    title: string;
    /** Give more info about the form below */
    description?: string | JSX.Element;
}

const FormContainerHeader = ({ title, description, ...rest }: FormContainerHeaderProps): React.JSX.Element => {
    const descriptionIsString = typeof description === 'string';

    return (
        <div className="form-title-container" {...rest}>
            <h1 className="title">{title}</h1>
            <div className="description">{descriptionIsString ? <p>{description}</p> : description}</div>
        </div>
    );
};

export default FormContainerHeader;
